import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const humbBtn = document.querySelector('.l-header__humb');
const humbMenu = document.querySelector('.l-header__menu');
const humbMenuTxt = document.querySelector('.l-header__humb--txt');
const body = document.querySelector('html');

class Nav {
  openFlag = false;

  constructor() {
    this.events();
  }

  // イベント
  events() {
    humbBtn.addEventListener('click', this.onClickDispatcher.bind(this));
  }

  // メソッド
  onClickDispatcher() {
    if (this.openFlag === false) {
      this.navOpen();
    } else if (this.openFlag === true) {
      this.navClose();
    }
  }

  navOpen() {
    const TL = gsap.timeline();
    TL.add(() => body.classList.add('body-no-scroll'))
      .add(() => humbBtn.classList.add('active'))
      .add(() => humbMenu.classList.add('active'))
      .add(() => (humbMenuTxt.textContent = '閉じる'));
    this.openFlag = true;
  }
  navClose() {
    const TL = gsap.timeline();
    TL.add(() => body.classList.remove('body-no-scroll'))
      .add(() => humbBtn.classList.remove('active'))
      .add(() => humbMenu.classList.remove('active'))
      .add(() => (humbMenuTxt.textContent = 'MENU'));
    this.openFlag = false;
  }
}
export default Nav;
